/* eslint-disable react-hooks/exhaustive-deps */
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import { Page, Text, View, Document, StyleSheet, pdf, Font, Image } from "@react-pdf/renderer";
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import Rudaw from '../../../assets/fonts/rudawregular2.ttf';
import { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import { formatPrice } from '../../../utils';
import ReportService from '../../../services/reportService';
import { useCompany } from '../../../provider/companyProvider';
import { fileApiRoute } from "../../../services/networkService";


const registerFont = () => {
    Font.register({
        family: 'Rudaw',
        fonts: [{ src: Rudaw, fontWeight: 'normal' }],
    });
};

const PdfMoneyMovementReport = ({ data }) => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.language !== 'en';
    const [reports, setReports] = useState([]);
    const [total, setTotal] = useState(0);
    const [totalCome, setTotalCome] = useState(0);
    const [totalGo, setTotalGo] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const { business } = useCompany();

    const styles = StyleSheet.create({
        page: {
            padding: 30,
            direction: isRTL ? 'rtl' : 'ltr',
            fontFamily: 'Rudaw',
        },
        title: {
            fontSize: 18,
            textAlign: "center",
            fontWeight: "bold",
            marginTop: 10
        },
        infoSection: {
            marginBottom: 10,
            padding: 8,
            border: "1px solid #ccc",
            borderRadius: 5,
            fontSize: 14,
        },
        row: {
            flexDirection: isRTL ? 'row-reverse' : 'row',
            paddingVertical: 3,
            alignItems: 'center',
            direction: isRTL ? 'rtl' : 'ltr',
        },
        key: {
            fontWeight: 'bold',
            width: '40%',
            textAlign: isRTL ? 'right' : 'left',
            direction: isRTL ? 'rtl' : 'ltr',
        },
        value: {
            flex: 1,
            textAlign: isRTL ? 'right' : 'left',
            paddingLeft: 1,
        },
        table: {
            display: "table",
            width: "auto",
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "#ccc",
            marginBottom: 20,
        },
        tableRow: {
            flexDirection: isRTL ? "row-reverse" : "row",
        },
        tableCell: {
            padding: 5,
            borderRightWidth: 1,
            borderBottomWidth: 1,
            borderColor: "#ccc",
            textAlign: "center",
            fontSize: 10,
        },
        footer: {
            display: 'flex',
            flexDirection: isRTL ? 'row-reverse' : 'row',
            justifyContent: 'space-between',
            paddingVertical: 3,
            alignItems: 'center',
            direction: isRTL ? 'rtl' : 'ltr',
            textAlign: isRTL ? 'right' : 'left',
            fontSize: 12
        },
    });

    const MyDocument = () => {
        const { branch, time } = data;

        return (
            <Document>
                <Page size="A4" style={styles.page}>
                    {/* Title */}
                    <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "center", marginBottom: 4 }}>
                        <Image src={`${fileApiRoute}/${business.logo}`} style={{ width: 100, height: 50 }} />
                        <View style={{ width: 10 }}></View>
                        <Text style={styles.title}>{t('moneyMovemenetReport')}</Text>
                    </View>


                    {/* Information Section */}
                    <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                        {(branch) &&
                            <View style={[styles.infoSection, { flex: 1, marginRight: 10 }]}>
                                {branch && (
                                    <View style={styles.row}>
                                        <Text style={styles.key}>{t('branch')}:</Text>
                                        <Text style={styles.value}>{branch.name}</Text>
                                    </View>
                                )}
                            </View>
                        }

                        <View style={[styles.infoSection, { flex: 1 }]}>
                            {time && (
                                time.time !== '' ? (
                                    <View style={styles.row}>
                                        <Text style={styles.key}>{t('duration')}:</Text>
                                        <Text style={styles.value}>{t(time.time)}</Text>
                                    </View>
                                ) : (
                                    <>
                                        <View style={styles.row}>
                                            <Text style={styles.key}>{t('startDate')}:</Text>
                                            <Text style={styles.value}>
                                                {dayjs(time.from).format('DD/MM/YYYY')}
                                            </Text>
                                        </View>
                                        <View style={styles.row}>
                                            <Text style={styles.key}>{t('endDate')}:</Text>
                                            <Text style={styles.value}>
                                                {dayjs(time.to).format('DD/MM/YYYY')}
                                            </Text>
                                        </View>
                                    </>
                                )
                            )}
                            <View style={styles.row}>
                                <Text style={styles.key}>{t('currentDate')}:</Text>
                                <Text style={styles.value}>
                                    {dayjs(new Date()).format('DD/MM/YYYY')}
                                </Text>
                            </View>
                        </View>
                    </View>


                    {/* Table */}
                    <View style={styles.table}>
                        {/* Table Header */}
                        <View style={[styles.tableRow, { backgroundColor: "#f0f0f0" }]}>
                            <Text style={[styles.tableCell, { width: '25%' }]}>{t('date')}</Text>
                            <Text style={[styles.tableCell, { width: '25%' }]}>{t('goAmount')}</Text>
                            <Text style={[styles.tableCell, { width: '25%' }]}>{t('comeAmount')}</Text>
                            <Text style={[styles.tableCell, { width: '25%' }]}>{t('netAmount')}</Text>
                        </View>

                        {/* Table Rows */}
                        {reports?.map((report, index) => (
                            <View key={index} style={styles.tableRow}>
                                <Text style={[styles.tableCell, { width: '25%' }]}>{report.date}</Text>
                                <Text style={[styles.tableCell, { width: '25%' }]}>{formatPrice(report.goAmount)}</Text>
                                <Text style={[styles.tableCell, { width: '25%' }]}>{formatPrice(report.comeAmount)}</Text>
                                <Text style={[styles.tableCell, { width: '25%' }]}>{formatPrice(report.netAmount)}</Text>
                            </View>
                        ))}
                    </View>

                    {/* Totals Section */}
                    <View style={styles.footer}>
                        <Text >{t('totalGo')}: {formatPrice(totalGo)}</Text>
                        <Text >{t('totalCome')}: {formatPrice(totalCome)}</Text>
                        <Text >{t('netTotal')}: {formatPrice(total)}</Text>
                    </View>
                </Page>
            </Document>
        );
    };


    const fetchReport = async () => {
        try {
            setIsLoading(true);
            const filters = data && {
                branchId: data.branch && data.branch.id,
                ...data.time
            };

            const responseData = await ReportService.fetchMoneyMovemenets(filters);
            const { reports, totalCome, totalGo, total } = responseData;

            setReports(reports);
            setTotalCome(totalCome);
            setTotalGo(totalGo);
            setTotal(total);
        } catch (error) {
            console.error("Failed to fetch report:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handlePrint = async () => {
        registerFont();
        await fetchReport();
    };

    useEffect(() => {
        if (reports.length > 0) {
            (async () => {
                try {
                    const blob = await pdf(<MyDocument />).toBlob();
                    if (blob) {
                        const url = URL.createObjectURL(blob);
                        window.open(url);
                    } else {
                        console.error("Failed to generate PDF blob.");
                    }
                } catch (error) {
                    console.error("Error generating PDF:", error);
                }
            })();
        }
    }, [reports]);

    return (
        // <PDFDownloadLink document={<MyDocument />} fileName="example.pdf">
        isLoading ? <CircularProgress size={28} /> :
            <LocalPrintshopOutlinedIcon sx={{ cursor: 'pointer' }} fontSize="medium" onClick={handlePrint} />
        // </PDFDownloadLink>
    );
}

export default PdfMoneyMovementReport;